
<div
  :class="
    classes(
      n(),
      computedDisabled && n('--disabled'),
      computedChecked && n('--checked'),
      theme && n(`--${theme}`),
      isIconOnly && n('--icon-only')
    )
  "
  role="checkbox"
  :aria-checked="computedChecked"
  :aria-disabled="computedDisabled"
  @click="handleClick"
>
  <!-- 内容区域 -->
  <div :class="n('content')">
    <div :class="n('main')">
      <div
        v-if="!isIconOnly"
        :class="n('info')"
      >
        <!-- 主文案 -->
        <div
          v-if="label"
          :class="n('label')"
        >
          {{ label }}
        </div>
        <!-- 描述文案 -->
        <div
          v-if="desc"
          :class="n('desc')"
        >
          {{ desc }}
        </div>
      </div>
      <div :class="n('icon-wrapper')">
        <DoneIcon
          v-if="computedChecked"
          :class="n('checked-icon')"
          aria-hidden="true"
        />
        <CheckboxunselectedOIcon
          v-else
          :class="n('unchecked-icon')"
          aria-hidden="true"
        />
      </div>
    </div>
  </div>
</div>
